'use client';

import styles from '@/blocks/components/Controls/Pagination/styles.module.scss';
import { UsePaginationItem } from '@mui/material/usePagination/usePagination';
import classNames from 'classnames';

export const PaginationButton = (
  props: React.PropsWithChildren<{
    type: UsePaginationItem['type'];
    selected?: boolean;
    onClick: (...args: any) => void;
  }>,
) => {
  function onPaginationButtonClick(e: React.MouseEvent<HTMLButtonElement>) {
    if (props.type !== 'page') {
      return;
    }
    props.onClick(e);
  }

  return (
    <button
      className={classNames(
        styles.basePaginationItem,
        styles.paginationButton,
        props.selected && styles.selected,
        props.type !== 'page' && styles.ellipsis,
      )}
      onClick={onPaginationButtonClick}
    >
      {props.children}
    </button>
  );
};
